import Summit from '../pages/summit/Summit';
import Conference from "../pages/conference/Conference";
import ConferenceInvoice from "../pages/conference/components/ConferenceInvoice";
import ConferenceReceipt from "../pages/conference/components/ConferenceReceipt";
import Bootcamp from "../pages/bootcamp/Bootcamp";
import BootcampReceipt from "../pages/bootcamp/components/BootcampReceipt";
import BootcampInvoice from "../pages/bootcamp/components/BootcampInvoice";
import Training from "../pages/training/Training";
import TrainingInvoice from "../pages/training/components/TrainingInvoice";
import TrainingReceipt from "../pages/training/components/TrainingReceipt";
import Talk from "../pages/talk/Talk";
import TalkInvoice from "../pages/talk/components/TalkInvoice";
import TalkReceipt from "../pages/talk/components/TalkReceipt";
import Resources from "../pages/resources/Resources";
import Stickers from "../pages/stickers/Stickers";
import NewStickers from "../pages/stickers/components/NewStickers";
import StickersUpload from "../pages/stickers/components/StickersUpload";
import EditStickers from "../pages/stickers/components/EditStickers";
import NfcCard from "../pages/nfc-card/NfcCard";

export const mobileRoutes = [
  { path: "/mobile/summit", element: <Summit /> },
  { path: "/mobile/conferences", element: <Conference /> },
  { path: "/mobile/conference/invoice", element: <ConferenceInvoice /> },
  { path: "/mobile/conference/receipt/:id", element: <ConferenceReceipt /> },
  { path: "/mobile/bootcamp", element: <Bootcamp /> },
  { path: "/mobile/bootcamp/receipt", element: <BootcampReceipt /> },
  { path: "/mobile/bootcamp/invoice", element: <BootcampInvoice /> },
  { path: "/mobile/training", element: <Training /> },
  { path: "/mobile/training/invoice", element: <TrainingInvoice /> },
  { path: "/mobile/training/receipt/:id", element: <TrainingReceipt /> },
  { path: "/mobile/talk", element: <Talk /> },
  { path: "/mobile/talk/invoice", element: <TalkInvoice /> },
  { path: "/mobile/talk/receipt/:id", element: <TalkReceipt /> },
  { path: "/mobile/resources", element: <Resources /> },
  { path: "/mobile/sticker", element: <Stickers /> },
  { path: "/mobile/nfc-card", element: <NfcCard /> },
  { path: "/mobile/new/stickers", element: <NewStickers /> },
  { path: "/mobile/stickers/upload/:id", element: <StickersUpload /> },
  { path: "/mobile/stickers/edit/:id", element: <EditStickers /> },
];
